<!--
 * @description     中间画板
 *
 * @author          重阳
 * @create          2019-10-16 11:00
-->

<style scoped lang="scss">
  .sketchpad-box {
    overflow: auto;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    .sketchpad {
      display: inline-block;
      width: 960px;
      height: 700px;
      position: absolute;
      left: 50%;
      margin-left: -480px;
      margin-top: 100px;
      margin-bottom: 100px;
      z-index: 10;
      background: #FFFFFF;
      box-shadow: 0 0 2px 2px rgba(0, 0, 0, .1);
    }
    .inputBox {
      display: none;
    }
  }
</style>

<template>
  <div class="sketchpad-box" :style="boxStyle">
    <div class="sketchpad" id="sketchpad">
      <!-- 文本输入框 -->
      <input class="inputBox" autofocus value="">
    </div>
  </div>
</template>

<script>
  import utils from '../global/utils'
  export default {
    name: 'Sketchpad',
    data () {
      return {
        // 面板样式
        panelStyle: {
          left: null,
          right: null
        }
      }
    },
    computed: {
      boxStyle () {
        let _t = this
        let boxStyle = {}
        let keys = Object.keys(_t.panelStyle)
        keys.forEach(key => {
          let panelStyle = _t.panelStyle[key]
          if (panelStyle) {
            // 位置数据
            let positionVal = isNaN(parseInt(panelStyle[key])) ? 0 : parseInt(panelStyle[key])
            let width = isNaN(parseInt(panelStyle.width)) ? 0 : parseInt(panelStyle.width)
            boxStyle[key] = positionVal + width + 'px'
          }
        })
        return boxStyle
      }
    },
    created () {
      let _t = this
      utils.bus.$on('editor/panel/toggle', function (data) {
        _t.$set(_t.panelStyle, data.name, data.style)
      })
    }
  }
</script>
